import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaymentService } from './payment.service';

@Injectable({ providedIn: 'root' })
export class ChargesService {
    constructor(
        private http: HttpClient,
        private paymentService: PaymentService
    ) { }

    getTotalChargesByCities(campaignId: string) {
        return this.paymentService.getCampaignCharges(campaignId);
    }

    addCharges(data, campaignId) {
        return this.paymentService.addCampaignCharges(campaignId, data);
    }

    calculateTotalCharges(campaignId: string, supplierId: number) {
        return this.paymentService.calculateTotalCharges(campaignId, supplierId);
    }
}
